module.exports = __webpack_public_path__ + "img/contract_renew.af6ee97d.svg";